import React, { Component } from 'react';
import QRCode from 'qrcode.react';
import QRLoaderContainer from '../../containers/QRLoaderContainer';
import RetrySetupContainer from '../../containers/RetrySetupContainer';
import styles from './qr.module.scss';

export default class QR extends Component {
    setupPayload = {};

    capitalizeFirstLetter(string) {
        return string[0].toUpperCase() + string.slice(1);
    }

    componentDidMount() {
        this.setupPayload = {};
        const stepsCopy = [...this.props.steps];

        for (const step of stepsCopy) {
            if (step.key !== 'summary' && step.key !== 'qr' && step.key !== 'introduction') {
                const capitalizedStepName = this.capitalizeFirstLetter(step.key);
                const stepPayload = { ...step };

                delete stepPayload.key;
                delete stepPayload.Key;
                delete stepPayload.description;
                delete stepPayload.title;
                delete stepPayload.Completed;
                delete stepPayload.AbleToComplete;
                delete stepPayload.InitialValid;

                switch (step.key) {
                    case 'networking':
                        stepPayload.DNSServer = stepPayload.DNSServer.split(',');
                        this.setupPayload[capitalizedStepName] = stepPayload;

                        break;
                    case 'trunks':
                        this.setupPayload['Trunks'] = stepPayload.Trunks;

                        break;
                    case 'users':
                        this.setupPayload['Extensions'] = stepPayload;

                        break;
                    default:
                        this.setupPayload[capitalizedStepName] = stepPayload;

                        break;
                }
            }
        }

        this.props.getSetupStateRequest(this.setupPayload);
    }

    render() {
        return (
            <div className={styles.container}>
                {
                    this.props.isCompleting
                        ? null
                        : this.props.error
                            ? <RetrySetupContainer payload={this.setupPayload} />
                            :
                            <div>
                                <div className={styles.qrContainer}>
                                    <QRCode
                                        value={JSON.stringify({
                                            url: this.props.steps[this.props.steps.length - 2].URLSetup,
                                            api_key: 'setup_manager',
                                            identifier: this.props.steps[this.props.steps.length - 2].Hash
                                        })}
                                        renderAs="svg"
                                        size={240}
                                    />
                                </div>
                            </div>
                }
                {this.props.isCompleting && <QRLoaderContainer size={48} />}
            </div>
        );
    }
}
